import React from 'react';
import { convertToHtml } from '@guuru/markdown-common';
import ChatMessageBubble from '../ChatMessageBubble';
import { AnswerText } from './style';
import TextMessage from '../TextMessage';

interface HtmlMessageProps {
  message: {
    i18n: string;
    type?: string;
    smartFormStyle?: boolean;
  };
}

const HTMLMessage = function ({ message }: HtmlMessageProps) {
  return (
    <ChatMessageBubble message={message}>
      <TextMessage>
        <AnswerText
          dangerouslySetInnerHTML={{ __html: convertToHtml(message.i18n) }}
        />
      </TextMessage>
    </ChatMessageBubble>
  );
};

export default HTMLMessage;
